import React, { PropsWithChildren, useEffect, useState } from "react";
import { X } from "lucide-react";
import "rsuite/dist/rsuite.min.css";
import styled from "styled-components";
import DynamicConfirmationModal from "./DynamicConfirmationModal";

interface DrawerI {
  openWithHeader: boolean;
  setOpenWithHeader: React.Dispatch<React.SetStateAction<boolean>>;
  drawerTitle: string;
  customHeader?: boolean;
  size: "lg" | "sm" | "xs" | "full";
}

const GlobalDrawer: React.FC<PropsWithChildren<DrawerI>> = ({
  openWithHeader,
  setOpenWithHeader,
  drawerTitle,
  children,
  size,
  customHeader = false,
}) => {
  const [formCloseModel, setFormCloseModel] = useState(false);

  useEffect(() => {
    if (openWithHeader) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  }, [openWithHeader]);

  return (
    <Root className={openWithHeader ? "active" : ""}>
      <DynamicConfirmationModal
        onConfirmation={() => {
          setFormCloseModel(false);
          setOpenWithHeader(false);
        }}
        showModal={formCloseModel}
        toggleModal={() => {
          setFormCloseModel(false);
        }}
        title="Are you sure to want to Close this"
      />

      <div className="bg_action" onClick={() => setFormCloseModel(true)}></div>
      <div
        style={{
          width: size == "lg" ? "968px" : size == "sm" ? "500px" : "360px",
        }}
        className="content_card"
      >
        <div className="drawer_header">
          <div className="header_content">
            <h2 className="title">{drawerTitle}</h2>
          </div>

          {!customHeader ? (
            <button
              onClick={() => setFormCloseModel(true)}
              className="cancel_button"
            >
              Cancel
            </button>
          ) : (
            <div className="header_actions">
              <span
                className="close-btn"
                onClick={() => {
                  setOpenWithHeader(false);
                }}
              >
                <X size={20} />
              </span>
            </div>
          )}
        </div>
        <div className="content_body">{children}</div>
      </div>
    </Root>
  );
};

export default GlobalDrawer;

const Root = styled.section`
  & span {
    font-size: 24px;
    font-family: "Gilroy-Bold";
    color: #272c36;
  }

  /* Hide the cancel svg icon */
  &
    button.rs-drawer-body-close.rs-btn-icon.rs-btn-icon-placement-left.rs-btn.rs-btn-subtle.rs-btn-sm {
    display: none;
  }
  display: none;
  &.active {
    display: block;
  }
  .drawer_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: #ffffff;
    position: sticky;
    top: 0px;
    z-index: 999;
    min-height: 60px;
    border-bottom: 1px solid #e5e7eb;
  }

  .header_content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }

  .header_actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .drawer_header div span {
    cursor: pointer;
    margin-bottom: 0;
  }

  .bg_action {
    background: #0000000a;
    position: fixed;
    left: 0px;
    width: 100%;
    height: 100%;
    top: 0px;
    z-index: 9999;
    /* backdrop-filter: blur(1px); */
    cursor: pointer;
  }
  .cancel_button {
    background: #ef4444;
    color: #fff;
    font-family: "Gilroy-Medium";
    font-weight: 600;
    font-size: 14px;
    border: none;
    border-radius: 6px;
    padding: 8px 14px;
    cursor: pointer;
    transition: all 0.15s ease;
    
    &:hover {
      background: #dc2626;
      transform: translateY(-1px);
    }
  }

  .close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: #f3f4f6;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.15s ease;
    
    &:hover {
      background: #e5e7eb;
      color: #374151;
      transform: translateY(-1px);
    }
  }

  h2.title {
    font-size: 18px;
    color: #1f2937;
    margin: 0px;
    line-height: 1.25;
    font-weight: 600;
    font-family: 'Gilroy-Bold';
  }

  .content_card {
    position: fixed;
    top: 0px;
    right: -4px;
    z-index: 9999;
    background: #ebf0f4;
    height: 101%;
    overflow: scroll;
    margin-right: -10px;
  }
  .content_body {
    padding: 20px;
    height: 94%;
    overflow-y: auto;
    overflow-x: hidden;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #d1d5db;
      border-radius: 3px;
      
      &:hover {
        background: #9ca3af;
      }
    }
  }
  
  .content_body .form-label {
    font-weight: 600;
    color: #374151;
    font-family: 'Gilroy-Regular';
    font-size: 14px;
    margin-bottom: 8px;
    display: block;
  }

  .content_body div button {
    height: auto;
    min-height: 42px;
    font-weight: 500;
    color: #374151;
    font-family: 'Gilroy-Regular';
    padding: 12px 16px;
    line-height: 1.4;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #ffffff;
    transition: all 0.15s ease;
    width: 100%;
    text-align: left;
    margin-bottom: 8px;
    
    &:hover {
      background: #f9fafb;
      border-color: #d1d5db;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
`;